import TemplateView from '../../../../../TemplateView'
import PromoCodeEditor from './PromoCodeEditor'
import messageResource from '../../../../../messageResource'
import {connect} from '../../../../../redux/utils'
import {bindActionCreators} from 'redux'

import {getBasePrice, getOptionalPrices, getPromoCode, getPromoEditorMode, getTotalPrice, isPromoInvalid} from '../selectors'
import {applyPromoCode, removePromoCode, setPromoCode, setPromoEditorMode} from '../actions'
import NumberFormatter from '../../../../../number_formatter'
import PriceList from './PriceList'
import {priceType} from '../../../constants'
import {DateFormat} from '../../../../../date_format'

class OrderSummary extends TemplateView {
    constructor({
        setPromoEditorMode = () => {},
        setPromoCode = () => {},
        applyPromoCode = () => {},
        removePromoCode = () => {},
    } = {}) {
        super()

        this.actions = {
            setPromoEditorMode,
            setPromoCode,
            applyPromoCode,
            removePromoCode,
        }

        this.state = {
            summaryText: '',
            startDate: new Date(),
            endDate: new Date(),
            usersTotalText: '',

            promoEditorMode: '',
            promoCode: '',
            promoInvalid: false,

            totalPrice: 0,
            basePrice: 0,
            basePriceDescription: '',

            optionalPrices: [
                // has a data format like
                // {
                //     amount: null,
                //     description: null,
                //     type: priceType.PROMO_DISCOUNT,
                // },
            ],
        }

        this.onStatePropertyChanged('summaryText', (summaryText) => {
            this.$users.text(summaryText)
        })

        this.onStatePropertyChanged('periodText', (periodText) => {
            this.$period.text(periodText)
        })

        this.onStatePropertyChanged('usersTotalText', (usersTotalText) => {
            this.$usersInTotal.text(usersTotalText)
            this.$usersInTotal.toggle(!!usersTotalText)
        })

        this.onAnyStatePropertyChanged(['promoEditorMode', 'promoCode', 'promoInvalid'], () => {
            this.promoEditor.setState({
                mode: this.state.promoEditorMode,
                promoCode: this.state.promoCode,
                promoInvalid: this.state.promoInvalid,
            })
        })

        this.onStatePropertyChanged('totalPrice', (totalPrice) => {
            this.$totalPrice.text(messageResource.getMessage('licenses.price', [this._getFormattedPrice(totalPrice)]))
        })

        this.onAnyStatePropertyChanged(['basePrice', 'basePriceDescription', 'optionalPrices'], () => {
            const formattedOptionalPrices = this.state.optionalPrices.map((price) => {
                return {
                    ...price,
                    amount: this._getFormattedPrice(price.amount),
                }
            })

            this.priceList.setState({
                prices: [
                    {
                        amount: this._getFormattedPrice(this.state.basePrice),
                        description: this.state.basePriceDescription,
                        type: priceType.BASE_PRICE,
                    },
                    ...formattedOptionalPrices,
                ]
            })
        })

        this.onAnyStatePropertyChanged(['startDate', 'endDate'], () => {
            this.$period.text(this._getPeriodText())
        })
    }

    templateHtml() {
        return '<div class="orderSummaryComponent">' +
               '    <div class="orderHeader"><%=orderSummary%></div>' +
               '    <div class="summarySection">' +
               '        <div class="users"/>' +
               '        <div class="period"/>' +
               '        <div class="usersInTotal"/>' +
               '    </div>' +
               '    <div class="promoSection"/>' +
               '    <div class="priceListSection"/>' +
               '    <div class="totalSection">' +
               '        <div class="totalHeader"><%=total%></div>' +
               '        <div class="totalPrice"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            orderSummary: 'licenses.purchase_lightbox.check.order_summary',
            total: 'licenses.purchase_lightbox.check.total',
        }
    }

    afterRender() {
        this.$users = this.find('.summarySection .users')
        this.$period = this.find('.summarySection .period')
        this.$usersInTotal = this.find('.summarySection .usersInTotal')

        this.$totalPrice = this.find('.totalSection .totalPrice')

        this.promoEditor = new PromoCodeEditor({
            changePromoModeCallback: this.actions.setPromoEditorMode,
            changePromoCallback: this.actions.setPromoCode,
            applyPromoCallback: this.actions.applyPromoCode,
            removePromoCallback: this.actions.removePromoCode,
        }).init(this.find('.promoSection'))

        this.priceList = new PriceList().init(this.find('.priceListSection'))

        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

        this.dateFormatter = new DateFormat('MMM dd, yyyy')
        this.dateFormatterWithoutYear = new DateFormat('MMM dd')
    }

    _getFormattedPrice(priceInCents) {
        return this.numberFormatter.format(priceInCents / 100)
    }

    _getPeriodText() {
        let dateStart = this.state.endDate.getFullYear() === this.state.startDate.getFullYear() ? this.dateFormatterWithoutYear.formatDate(this.state.startDate)
                                                                                                : this.dateFormatter.formatDate(this.state.startDate)
        let dateEnd = this.dateFormatter.formatDate(this.state.endDate)
        return messageResource.getMessage('range.custom.pattern', [dateStart, dateEnd])
    }
}

export default connect(
    (state) => ({
        promoEditorMode: getPromoEditorMode(state),
        promoCode: getPromoCode(state),
        promoInvalid: isPromoInvalid(state),

        basePrice: getBasePrice(state),
        totalPrice: getTotalPrice(state),
        optionalPrices: getOptionalPrices(state),
    }),
    (dispatch) => ({
        setPromoEditorMode: bindActionCreators(setPromoEditorMode, dispatch),
        setPromoCode: bindActionCreators(setPromoCode, dispatch),
        applyPromoCode: bindActionCreators(applyPromoCode, dispatch),
        removePromoCode: bindActionCreators(removePromoCode, dispatch),
    })
)(OrderSummary)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/orderSummary/OrderSummary.js